export default [
   {
    path: "/configuracion-institucion",
    name: "configuracion-institucion",
    component: () =>
      import(
        /* webpackChunkName: "configuracion-institucion" */ "@/views/configuracionInstitucion/ConfiguracionInstitucionList.vue"
      ),
  },
  {
    path: "/configuracion-institucion/:id",
    name: "form-configuracion-institucion",
    component: () =>
      import(
        /* webpackChunkName: "form-configuracion-institucion" */ "@/views/configuracionInstitucion/ConfiguracionForm.vue"
      ),
  },
    
    
]